export const ZONES_LOADING = "scooter/zones/loading";
export const ZONES_ERROR = "scooter/zones/error";
export const ZONES_LIST = "scooter/zones/list";



// WEBPACK FOOTER //
// ./src/actions/scooter/zones/constants.js